import { render, staticRenderFns } from "./personpoint.vue?vue&type=template&id=2eeff156&scoped=true&"
import script from "./personpoint.vue?vue&type=script&lang=js&"
export * from "./personpoint.vue?vue&type=script&lang=js&"
import style0 from "./personpoint.vue?vue&type=style&index=0&id=2eeff156&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eeff156",
  null
  
)

export default component.exports